import ExitIcon from './component'

export default ExitIcon